import { RDLivestock } from '@cibo/core'
import { Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const LivestockCell = ({ traitId, year, params }: TraitCellDisplayProps<RDLivestock>) => {
  const { t } = useTranslation('@cibo/landmanager/LivestockEditor')
  const {
    palette: {
      text: { secondary },
    },
  } = useTheme()
  const detail = params.row.findDetail({ traitId, year })
  const input = detail?.input

  if (input?.species) {
    return (
      <Stack>
        <Typography>
          {t('species', {
            ns: '@cibo/landmanager/LivestockSpecies',
            context: input.species,
          })}
        </Typography>
        <Typography variant="body2" style={{ color: secondary }}>
          {[
            !!input.headcount && t('headCount', { count: input.headcount }),
            !!input.daysGrazing && t('daysGrazing', { count: input.daysGrazing }),
          ]
            .filter(Boolean)
            .join(', ')}
        </Typography>
      </Stack>
    )
  }

  return <Typography>{detail?.result ? t('yes') : t('no')}</Typography>
}
